import styled from 'styled-components'
import { lgStyle, smStyle } from '@/components/Adapter'

export const PriceChartStyled = styled.div`
  display: flex;
  position: relative;

  .price-fundraising-tabs {
    overflow: auto;
    flex-wrap: nowrap;
    overflow-x: scroll;
    width: 100%;

    ${lgStyle} {
      width: calc(100% - 530px);
    }

    ::-webkit-scrollbar {
      width: 0px;
      height: 0px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 0px;
      background: hsla(215, 17%, 59%, 0.2);
    }
    &::-webkit-scrollbar-track {
      border-radius: 0px;
    }
  }
`

export const PriceHeartChartSkeletonContainerDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 4px;
  margin-top: 24px;
`

export const ThermalMapTip = styled.div`
  margin-top: 12px;
  color: #919499;
  font-size: 14px;
`

export const CoinChartsStyled = styled.div`
  width: 100%;
  margin-top: 24px;
  border-radius: 4px;
  height: 285px;

  ${smStyle} {
    border-radius: 8px;
    height: 410px;
  }

  .mantine-GateInputGroup-root {
    width: 240px;
  }

  .price-coin-trend-chart {
    height: 285px;
    ${smStyle} {
      height: 410px;
    }
  }

  .price-coin-perform-chart {
    height: 235px;

    ${smStyle} {
      height: 362px;
    }
  }
`

export const PriceChartTimeTabStyled = styled.div<{ isShow: boolean }>`
  display: ${({ isShow }) => (isShow ? 'block' : 'none')};
`
